import config from "../../../config";

export const account = 'Account/';
export const GetLoginType = account + 'GetLoginType';
export const ProcessLogin = account + 'ProcessLogin';
export const Token = `${config.publicUrl}Token`;
export const SSO = `${config.publicUrl}Sso?client_id=self&scope=resource&response_type=code&redirect_uri=${config.publicUrl}`;
export const CSFR = account +'CSRF';
export const GetSecurityInfo = account + 'GetSecurityInfo';
export const AddTwoFactorAutentication = account + 'AddTwoFactorAuthenticationDevice';
export const DisableTwoFactorAuthentication = account + 'DisableTwoFactorAuthentication';
export const ChangePassword = account + 'ChangePassword';
export const ForgttUsername = account + 'ForgotUsername';
export const UserForgotPassword = account + 'UserForgotPassword';
export const ResetPassword = account + 'ResetPassword';
export const Logout = account + 'Logout';
export const UpdateVerificationModalSelection = account + 'UpdateVerificationModalSelection';

export const GenerateTwoFactorAuthInfo = 'User/GenerateTwoFactorAuthInfo';

//Core API
export const Auth = 'Auth';
export const AccountDetails = 'user/AccountDetails';